import React from 'react'
import { DataGridPro, useGridApiRef } from '@mui/x-data-grid-pro';



const DataTable = (
    {
    rows,
    columns,
    loading,
    hideHeader = false,
    initialState,
    apiRef,
    ...restProps
}) => {

    return (
        <DataGridPro 
            apiRef={apiRef}
            rows={rows} 
            columns={columns} 
            loading={loading} 
            initialState={initialState}
            columnHeaderHeight={50}
            rowHeight={60}
            slots={{
                // Return null to hide column headers when hideHeader is true
                columnHeaders: hideHeader ? () => null : undefined,
            }}
            {...restProps}
            
        />
    )
}

export default DataTable